import React from 'react';
import { motion } from 'framer-motion';
export function ProtocolSection() {
  const phases = [{
    id: 'H',
    days: 'DÍAS 1—7',
    name: 'Hormonal',
    description: 'Reducir inflamación y acompañar el equilibrio hormonal. Los primeros días ayudan a que tu cuerpo reciba nuevas señales.'
  }, {
    id: 'E',
    days: 'DÍAS 8—14',
    name: 'Enzimática',
    description: 'Optimizar digestión, regular cortisol y mejorar uso de energía. Empezás a notar más energía y una sensación de mayor estabilidad.'
  }, {
    id: 'R',
    days: 'DÍAS 15—21',
    name: 'Restaurativa',
    description: 'Consolidar cambios y crear un nuevo punto de equilibrio. No es el final — es el comienzo de una nueva relación con tu cuerpo.'
  }];
  return <section className="bg-gradient-section py-20 md:py-28 px-5 md:px-8" data-id="element-195">
      <div className="max-w-2xl mx-auto" data-id="element-196">
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16 md:mb-20" data-id="element-197">
          <h2 className="font-display font-semibold text-[#F0E8D8] text-[34px] md:text-5xl leading-[1.1]" data-id="element-198">
            El método <span className="italic text-gradient-gold" data-id="element-199">H·E·R</span>
          </h2>
          <p className="uppercase tracking-[0.28em] font-body mt-5 text-[#F0E8D8] text-[13px]" data-id="element-200">
            Tres fases · 21 días · Tu fisiología
          </p>
        </motion.div>

        {/* Phases — editorial rows */}
        <div data-id="element-201">
          {phases.map((phase, i) => <motion.div key={phase.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.12
        }} className={`relative py-12 md:py-14 ${i !== 0 ? 'border-t-[0.5px] border-gold/12' : ''}`} data-id="element-202">
              {/* Giant ghost letter */}
              <span className="absolute -top-2 left-0 font-display font-medium text-[110px] md:text-[140px] leading-none text-gold/10 select-none pointer-events-none" data-id="element-203">
                {phase.id}
              </span>

              <div className="relative pl-1" data-id="element-204">
                {/* Days label */}
                <p className="text-right uppercase tracking-[0.2em] text-[11px] text-[#C8A870] font-semibold" data-id="element-205">
                  {phase.days}
                </p>

                {/* Gold tick */}
                <div className="h-px w-10 bg-gold/60 mt-10 md:mt-14 mb-5" data-id="element-206" />

                {/* Name */}
                <h3 className="font-display text-[28px] md:text-[34px] font-medium text-[#E8D5B0] leading-tight" data-id="element-207">
                  {phase.name}
                </h3>

                {/* Description */}
                <p className="font-body md:text-[16px] mt-4 max-w-md text-[#F0E8D8] text-[16px]" data-id="element-208">
                  {phase.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}